/**
 * Why a Baseline Compliance page's score is unknown: the stats call failed,
 * nothing has been scanned (`totalChecks` 0), or the baseline is still being
 * captured. Unknown is never zero; `composeComplianceBrief`'s `noData` input
 * turns the reason into the brief's copy.
 */
import { knownBaselinePct } from '@/components/Dashboard/v2/cc-score'
import type { ComplianceNoData } from '@/lib/compliance-brief'
import type { DashboardStats } from '@/types'

export type BaselineUnknown = ComplianceNoData

/** Why the baseline score is unknown, or null when it is a real number (or still loading). */
export function baselineUnknownReason(
  stats: DashboardStats | null | undefined,
  { loading, failed }: { loading: boolean; failed: boolean },
): BaselineUnknown | null {
  if (loading) return null
  if (failed || !stats || stats.activeDriftsKnown === false) return 'failed'
  if (stats.complianceScore?.baselineIncomplete) return 'incomplete'
  if (knownBaselinePct(stats) != null) return null
  return stats.activeDrifts > 0 ? 'incomplete' : 'unscanned'
}
